export default "__VITE_ASSET__DYfgPCQU__"